
   
import KAMPYLE_CONSTANT from "./KAMPYLE_CONSTANT";
import KAMPYLE_DATA from "./KAMPYLE_DATA";
import KAMPYLE_EVENT_DISPATCHER from "./KAMPYLE_EVENT_DISPATCHER";
import KAMPYLE_FUNC from "./KAMPYLE_FUNC";

import KAMPYLE_UTILS from "./KAMPYLE_UTILS";

export default {
  //In order to differentiate between top level domain and a previous cookie a client may have,
  // we add this prefix to each cookie in order to get it specifically and not the previous cookie
  TOP_LEVEL_DOMAIN_COOKIE_PREFIX: 'Tld-',

  startsWith: function(originalString, searchString, position) {
    return originalString.substr(position || 0, searchString.length) === searchString;
  },
  isIos: function() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  },
  isSafari: function(){
    // Chrome UA also contains "Safari"
    return navigator.userAgent.indexOf("Safari") > -1 && navigator.userAgent.indexOf("Chrome") < 0;
  },
  isiPhone: function () {
    return /iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  },
  isiPadOS13: function () {
    // iPad OS 13 + Safari may not return 'iPad' in it's userAgent or navigator.platform, so adding this special check
    return KAMPYLE_UTILS.isSafari() && !KAMPYLE_UTILS.isiPhone() &&
      (navigator.platform === 'MacIntel' || navigator.platform === 'Mac-Intel') && navigator.maxTouchPoints > 1;
  },
  isDesktop: function () {
    return KAMPYLE_DATA.getMemoryData('kampyleDevice') === KAMPYLE_CONSTANT.DEVICES.DESKTOP
  },

  triggerCustomEvent: function(eventName, data) {
    // CustomEvent API expect the payload to be passed via "detail" property in the customEvent object
    // Can see CusyomEvent API here: https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
    // Create and dispatch the event

    var e;

    data = data ? { detail: data } : {};
    e = new CustomEvent(eventName, data);

    try {
      window.dispatchEvent(e);
    } catch (e) {
      KAMPYLE_UTILS.showWarning('Could not trigger custom event ' + eventName);
    }
  },
  isDebugMode: function() {
    var region = KAMPYLE_DATA.getMemoryData('region');
    return (region === KAMPYLE_CONSTANT.REGIONS.DEV || region === KAMPYLE_CONSTANT.REGIONS.QA);
  },
  showErrorStack: function(e) {
    if (KAMPYLE_UTILS.isDebugMode()) {
      console.warn(e.stack);
    }
  },
  showWarning: function(message) {
    if (KAMPYLE_UTILS.isDebugMode()) {
      console.warn(message);
    }
  },
  addStyle: function(cssStyle, referencedDocument)  {
    //This function will be deprecated, after we will globably enabled cspRules provision and the element will be created by native js and not by innerHTML
    if(!KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.CSP_RULES)){
      referencedDocument = referencedDocument || window.document;
      var style = referencedDocument.getElementById('kampyleStyle');
      if (style === null) {
        style = referencedDocument.createElement('style');
        style.type = 'text/css';
        style.id = 'kampyleStyle';
        var head = referencedDocument.head || referencedDocument.getElementsByTagName('head')[0];
        head.appendChild(style);
      }
      if (style.styleSheet) {
        style.styleSheet.cssText += cssStyle;
      } else {
        style.appendChild(document.createTextNode(cssStyle));
        KAMPYLE_UTILS.setAnimationRule(KAMPYLE_CONSTANT.CSS_SETTINGS.ANIMATION_RULE_SPIN_NAME, '{0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); }}');
      }
    }
    else{
      console.error("Should not use this method if the provision csp rules is on");
    }
  },
  addAttributesOnElement: function(element,attributesObj){
    if(element && attributesObj){
      for(var key in attributesObj){
        if(attributesObj.hasOwnProperty(key) && element.setAttribute){
          element.setAttribute(key, attributesObj[key]);
        }
      }
    }
  },
  removeAttribute: function (element, name) {
    if (element && element.hasAttribute(name)) {
      element.removeAttribute(name);
    }
  },
  getViewportSize: function() {
    return {
      width: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
      height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
    };
  },
  getDocumentSize: function() {
    var body = document.body;
    var html = document.documentElement;
    var height = Math.max(
      body.scrollHeight || 0,
      body.offsetHeight || 0,
      html.clientHeight || 0,
      html.scrollHeight || 0,
      html.offsetHeight || 0
    );

    var width = Math.max(
      body.scrollWidth || 0,
      html.scrollWidth || 0,
      body.offsetWidth || 0,
      html.offsetWidth || 0,
      html.clientWidth || 0
    );
    return {
      width: width + (body.getBoundingClientRect ? body.getBoundingClientRect().left || 0 : 0),
      height: height + (body.getBoundingClientRect ? body.getBoundingClientRect().top || 0 : 0),
    };
  },
	getElementSize: function(element) {
		var height = Math.max(
			element.scrollHeight || 0,
			element.offsetHeight || 0,
			element.clientHeight || 0
		);

		var width = Math.max(
			element.scrollWidth || 0,
			element.offsetWidth || 0,
			element.clientWidth || 0
		);
		return {
			width: width ,
			height: height,
		};
  },
  getCurrentTimestamp: function(){
      return new Date().getTime();
  },
  getTimeDiff: function (time, format) {
    var datetime = typeof time !== 'undefined' ? time : '2014-01-01 01:02:03.123456';
    datetime = new Date(datetime).getTime();
    var now = KAMPYLE_UTILS.getCurrentTimestamp();
    
    if (isNaN(datetime)) {
      return '';
    }
    var miliSecDiff = 0;

    if (datetime < now) {
      miliSecDiff = now - datetime;
    } else {
      miliSecDiff = datetime - now;
    }

    switch (format) {
      case KAMPYLE_CONSTANT.TIME_FORMATS.SECONDS:
        return miliSecDiff.toFixed(1) / 1000;
      case KAMPYLE_CONSTANT.TIME_FORMATS.DAYS:
        return Math.floor(miliSecDiff / 1000 / 60 / 60 / 24); // millis in seconds / secons in minutes / minutes in hours / hours in days;
      default:
        return miliSecDiff;
    }
  },
  setEventHandler: function (elem, eventType, handler) {
    if (elem.addEventListener) {
      elem.addEventListener(eventType, handler, false);
    }
    else if (elem.attachEvent) {
      elem.attachEvent('on' + eventType, handler);
    }
  },

  subscribeToCustomEvent: function(eventType, handler) {
    // according to MDN https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/attachEvent
    // the recommendation is NOT to use EventTarget.attachEvent due to the fact that this function is incompitable with all other browsers
    if (window && window.addEventListener && typeof handler === "function") {
      window.addEventListener(eventType, function(event) {
        var payload = event && event.detail;
        handler.apply(null, [eventType, payload]);
      }, false);
    }
  },

	removeEventHandler: function (elem, eventType, handler) {
		if (elem.removeEventListener) {
			elem.removeEventListener(eventType, handler);
		} else if (elem.detachEvent) {
			elem.detachEvent('on' + eventType, handler);
		}
	},
  setElementStyle: function(element, styleObj, isImportant) {
    //#TODO - Add support for getting to objects so we could set style attributes with important and some not on one call.
    var k;
    var dashed;
    isImportant = !!isImportant ? 'important' : '';
    if (element) {
      for (k in styleObj) {
          if (styleObj.hasOwnProperty(k)) {
            if (isImportant && element && element.style.setProperty) {
              //Need to convert camel case to dash case for this api
              dashed = KAMPYLE_UTILS.camelToDash(k);
              try {
                element.style.setProperty(dashed, '' + styleObj[k], isImportant);
              }
              catch (e) {
                element.style.setProperty(dashed, '' + styleObj[k], '!' + isImportant);
              }


            }
            else {
              element.style[k] = styleObj[k];
            }


          }
        }
    }

  },
  setAnimationRule : function(ruleName, rule, iframe) {

    var allStyleSheets = iframe && iframe.styleSheets && iframe.styleSheets || !iframe && window.document.styleSheets;
    var mDigitalAnimationStylesheet = null;
    for(var i=0; i< allStyleSheets.length; i++) {
      if(allStyleSheets[i].title == KAMPYLE_CONSTANT.CSS_SETTINGS.STYLE_SHEET_ANIMATION_NAME) {
        mDigitalAnimationStylesheet = allStyleSheets[i];
      }
    }
    //If we find  mDigital animation sheet check if current rule exists
    if(mDigitalAnimationStylesheet) {
      for(var i=0; i< mDigitalAnimationStylesheet.cssRules.length; i++) {
        if(mDigitalAnimationStylesheet.cssRules[i].name == ruleName) {
          return;
        }
      }
    }

    //Create a new stylesheet and add the rule
    if(!mDigitalAnimationStylesheet) {
      var styleElement = document.createElement("style");
      styleElement.title = KAMPYLE_CONSTANT.CSS_SETTINGS.STYLE_SHEET_ANIMATION_NAME;

      if (iframe) {
        iframe.body.appendChild(styleElement);
        mDigitalAnimationStylesheet = iframe.styleSheets[iframe.styleSheets.length - 1];
      } else {
        document.body.appendChild(styleElement);
        mDigitalAnimationStylesheet = window.document.styleSheets[window.document.styleSheets.length - 1];
      }
    }
    var animationRule = '@keyframes ' + ruleName + ' ' + rule;
    var idx = mDigitalAnimationStylesheet.cssRules.length;
    mDigitalAnimationStylesheet.insertRule(animationRule, idx);
  },
  isNear: function(elementId, distance, event) {
    var element = document.getElementById(elementId);

    if (!element) {
      return false;
    }

    var left = KAMPYLE_UTILS.offset(element).left - distance;
    var top = KAMPYLE_UTILS.offset(element).top - distance;
    var right = left + element.clientWidth + (2 * distance);
    var bottom = top + element.clientHeight + (2 * distance);
    var x = event.pageX;
    var y = event.pageY;

    return (x > left && x < right && y > top && y < bottom);

  },
  offset: function(element) {
    if (!element) { return false; }

    var rect = element.getBoundingClientRect();

    var bodyElm = document.body;
    return {
      top: + rect.top + bodyElm.scrollTop,
      left: rect.left + bodyElm.scrollLeft,
    };
  },
  createIframe: function(src, width, height, iframeId) {
    var iframe = document.createElement('iframe');
    iframe.width = width;
    iframe.height = height;
    iframe.src = src;
    iframe.id = iframeId;
    iframe.style.border = 0;
    iframe.frameBorder = 0;
    iframe.style.display = 'inline-block';

    return iframe;
  },
  getUrlParam: function(name) {
    var params = location.search.substr(location.search.indexOf('?') + 1);
    //if no params from search, check maybe it is after hash
    if (params === '') {
      params = location.hash.substr(location.hash.indexOf('?') + 1);
    }
    var sval = null;
    params = params.split('&');
    var paramLenght = params.length;
      // split param and value into individual pieces
      for (var i = 0; i < paramLenght; i++)
     {
       var temp = params[i].split('=');
       /* jshint -W116 */
       if (temp && [temp[0]] == name) { sval = decodeURIComponent(temp[1]); }
       /* jshint +W116 */
     }
    return sval;
  },
  htmlDecode: function(inputHtml) {
    inputHtml = inputHtml || '';
    var re;
    re = new RegExp('&lt', 'g');
    inputHtml = inputHtml.replace(re, '<');
    re = new RegExp('&gt', 'g');
    inputHtml = inputHtml.replace(re, '>');

    return inputHtml;
  },
  escapeRegExp: function(str) {
      return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1');
  },
  replaceAll: function (str, find, replace) {
    return str.replace(new RegExp(KAMPYLE_UTILS.escapeRegExp(find), 'g'), replace);
  },
  sendMessageToIframe: function(iframeId, message) {
    var origin;
    var targetWindow;
    var iframe;

    if (!iframeId) { return; }

    iframe = document.getElementById(iframeId);

    if (!iframe || !iframe.getAttribute) {return;}

    var origin = iframe.getAttribute('origin') || '*';
    var targetWindow = iframe.contentWindow;

    if (targetWindow && targetWindow.postMessage)
    {
      if (message) {
        message.__isDigitalAction = true;
      }
      targetWindow.postMessage(JSON.stringify(message), origin);
    }
  },
  getZoomedIn: function () {
    var ZOOM_IN_THRESHOLD = 2.4;
    var DESKTOP_CONSTRAINT = 2;
    var browserZoom = { zoom: 1, constraint: 1, isZoomedIn: false };

    try {
        if (KAMPYLE_DATA.isMobile()) {
            browserZoom.zoom = window.visualViewport.scale;
            browserZoom.isZoomedIn = browserZoom.zoom >= ZOOM_IN_THRESHOLD;
            return browserZoom;
        }
        browserZoom.constraint = DESKTOP_CONSTRAINT;
        const isZoomFallbackEnabled = KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_ZOOM_FALLBACK);
        browserZoom.zoom = isZoomFallbackEnabled ? KAMPYLE_UTILS.getDesktopZoomFallback() : KAMPYLE_UTILS.getDesktopZoom();
        browserZoom.isZoomedIn = browserZoom.zoom >= ZOOM_IN_THRESHOLD;
    } catch (e) {
        return browserZoom;
    }
    return browserZoom;
  },
  getDesktopZoomFallback: function () {
    var browser = KAMPYLE_UTILS.getBrowser();
    var windowDPR = window.devicePixelRatio;
    var isHighDPI = false;

    // Safari
    if (browser.name === KAMPYLE_CONSTANT.BROWSERS.SAFARI) {
        return window.outerWidth / window.innerWidth;
    }
    // Firefox
    if (browser.name === KAMPYLE_CONSTANT.BROWSERS.FIREFOX) {
        if (windowDPR > 5) {
            isHighDPI = true;
        } else {
            isHighDPI = window.matchMedia(
                'only screen and (-webkit-min-device-pixel-ratio: 1.5),' +
                'screen and (min-resolution: 1.5dppx),' +
                'screen and (min-resolution: 144dpi)'
            ).matches;
        }
        return isHighDPI ? windowDPR * 0.5 : windowDPR;
    }
    // Chrome / Other
    var isHighDPIByWindowSize = window.outerWidth - (window.innerWidth * (windowDPR / 2)) <= 60;
    var isHighDPIByPixelDepth = false;
    if (window.screen && window.screen.pixelDepth) {
        isHighDPIByPixelDepth = window.screen.pixelDepth > 24;
    }
    isHighDPI = isHighDPIByWindowSize || isHighDPIByPixelDepth;
    return isHighDPI ? windowDPR * 0.5 : windowDPR;
  },
  getDesktopZoom: function () {
    var dpr = Number(window.devicePixelRatio.toFixed(2));
    var browser = KAMPYLE_UTILS.getBrowser().name;

    if (browser === KAMPYLE_CONSTANT.BROWSERS.FIREFOX) {
        var MIN_4K_PHYSICAL_WIDTH = 3000;
        var physicalScreenWidth = window.screen ? window.screen.availWidth * dpr : 0;
        var nativeDPR = physicalScreenWidth > MIN_4K_PHYSICAL_WIDTH ? 2 : 1;
        return dpr / nativeDPR;
    }

    if (browser === KAMPYLE_CONSTANT.BROWSERS.SAFARI || browser === KAMPYLE_CONSTANT.BROWSERS.FIREFOX) {
        return window.outerWidth / window.innerWidth;
    }

    // Tolerance for snapping near-100% zoom ratios to exactly 1 (scrollbar/chrome variance)
    var ZOOM_TOLERANCE = 0.03;
    if (window.outerWidth > 0 && window.innerWidth > 0) {
        var ratio = Math.round(window.outerWidth / window.innerWidth * 100) / 100;
        var impliedNativeDPR = dpr / ratio;
        var roundedNativeDPR = Math.round(impliedNativeDPR);
        var isReliable = roundedNativeDPR > 0 && Math.abs(impliedNativeDPR - roundedNativeDPR) < 0.15;

        if (isReliable) {
            return (ratio > 1 - ZOOM_TOLERANCE && ratio < 1 + ZOOM_TOLERANCE) ? 1 : ratio;
        }
    }

    var isHighDPI = window.screen && (window.screen.pixelDepth > 24 || window.screen.colorDepth > 24);
    return isHighDPI ? dpr / 2 : dpr;
  },
  getBrowser: function() {
    var ua = navigator.userAgent, tem,
    M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

    if (M[1] === 'Chrome') {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) {
        var temArr = tem.slice(1);
        return {
          name: temArr[0].replace('OPR', 'Opera'),
          version: temArr[1] || '', // not accurate in case of chrome & opera!
        };
      }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return {
      name: M[0],
      version: M[1],
    };
  },
  initEventSubscriptions: function(eventObj, callback) {
    for (var prop in eventObj)
    {
      if (eventObj.hasOwnProperty(prop))
      {
        KAMPYLE_EVENT_DISPATCHER.subscribe(prop, callback);
      }
    }

  },
  getRandomTimeMS: function(minValue,maxValue){
    return minValue+(Math.round(Math.random()*(maxValue-minValue)));
  },
  kampyleGetUserId: function() {
    //first check if userid exist in storage
    var userid = KAMPYLE_DATA.getData('kampyle_userid');
    if (!userid) {
      userid = KAMPYLE_UTILS.kampyleCreateUUID();
      KAMPYLE_DATA.setData('kampyle_userid', userid);
      if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ALTERNATIVE_UUID)) {
        KAMPYLE_DATA.setData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.MDIGITAL_ALTERNATIVE_UUID, KAMPYLE_UTILS.generateUUID());
      }

    }
    return userid;
  },
  kampyleCreateUUID: function() {
    var numAttempts = 8;
    var uuidAlgorithm = function() {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    };
    var uuid = uuidAlgorithm();

    for (var i = 0; i < numAttempts - 1; i++) {
      uuid += '-' + uuidAlgorithm();
    }

    return uuid;
  },
  removeAllContent: function (elem) {
    if (!elem) {return;}
    while (elem.firstChild) {
      elem.removeChild(elem.firstChild);
    }
    elem.parentNode.removeChild(elem);
  },
  safeToLower: function(toLower) {
    if (typeof toLower !== 'string')
    {
      return toLower;
    }
    else {
      return toLower.toLowerCase();
    }
  },
  getCookieFlagByProtocol: function(){
    var isSecureProtocol = KAMPYLE_UTILS.isSecureProtocol();
    var sameSiteValue = isSecureProtocol ? 'None' : 'Lax';
    var secure = isSecureProtocol ? 'Secure; ' : '';
    return 'SameSite=' + sameSiteValue + '; ' + secure; 
  },
  buildQueryParams: function (params) {
    return Object.keys(params || {}).map(function (key, index) {
      return (index === 0 ? '?' : '') + key + '=' + params[key];
    }).join('&') || '';
  },
  // Set cookie
  kampyleSetCookie: function (cookieName, cookieValue, exDays, propertySharedSubdomain) {
    var currDate = new Date();
    currDate.setTime(currDate.getTime() + (exDays * 24 * 60 * 60 * 1000));


    // attributes
    var expires = 'expires=' + currDate.toUTCString();
    var domain = propertySharedSubdomain ? ';domain=' + propertySharedSubdomain + ';' : '';
    var cookieFlag = KAMPYLE_UTILS.getCookieFlagByProtocol();
    cookieName = propertySharedSubdomain ? KAMPYLE_UTILS.TOP_LEVEL_DOMAIN_COOKIE_PREFIX + cookieName : cookieName;

    document.cookie = cookieName + '=' + cookieValue + '; ' + cookieFlag + expires + ';path=/' + domain;
  },

  isSecureProtocol: function () {
    return location.protocol === 'https:';
  },

  // get cookie - ONLY USE THIS
  getCookie: function (cookieName) {
    this.name = cookieName + '=';
    this.ca = document.cookie.split(';');
    for (var i = 0; i < this.ca.length; i++) {
      this.c = this.ca[i];
      while (this.c.charAt(0) === ' ') this.c = this.c.substring(1);
      if (this.c.indexOf(this.name) === 0) {
      	var valueToReturn = this.c.substring(this.name.length, this.c.length);
      	return valueToReturn;
			}
    }

    return null;
  },

  getDomainFromHost: function (host){
    if(host === null) {
      return null;
    }

    var portStartIndex = host.indexOf(':');
    var lastDomainCharacter = portStartIndex === -1 ? host.length : portStartIndex;
    return host.substring(0, lastDomainCharacter);
  },

  isHostMatchesSubdomain: function(host, subdomain){
    var domain = KAMPYLE_UTILS.getDomainFromHost(host);
    //avoid the situation where the domain is ending with the subdomain but it's not really a subdomain (e.g. someDomain.google.com compared to someDomaingoogle.com)
    return domain === subdomain || domain.endsWith('.' + subdomain);
  },

  // get cookie by name
  kampyleGetCookie: function (cookieName) {
    this.name = cookieName + '=';
    this.ca = document.cookie.split(';');
    for (var i = 0; i < this.ca.length; i++) {
      this.c = this.ca[i];
      while (this.c.charAt(0) === ' ') this.c = this.c.substring(1);
      if (this.c.indexOf(this.name) === 0) return this.c.substring(this.name.length, this.c.length);
    }

    return '';
  },

  getByteSize: function(s) {
    return encodeURIComponent('<q></q>' + s).length;
  },
  getAllKampyleData: function() {
    //TODO - Set all names as const variable
    var kampyleDataNames = [
      'SUBMITTED_DATE',
      'kampyleUserPercentile',
      'kampyleUserSession',
      'kampyle_userid',
      'kampyleInvitePresented',
      'DECLINED_DATE',
      'LAST_INVITATION_VIEW',
    ];

    if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ALTERNATIVE_UUID)) {
      kampyleDataNames.push(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.MDIGITAL_ALTERNATIVE_UUID);
    }

    if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.EXEMPT_FORMS_FROM_QUARANTINE)){
      kampyleDataNames.push(KAMPYLE_CONSTANT.SESSION_DATA_FIELDS.IS_SURVEY_SUBMITTED_IN_SESSION)
    }

    var result = {};

    for (var i = kampyleDataNames.length - 1; i >= 0; i--) {
      result[kampyleDataNames[i]] = KAMPYLE_DATA.getData(kampyleDataNames[i]);
    }

    return result;
  },
  kampyleDeleteCookie: function(cookieName, propertySharedSubdomain) {
    var domain = '';
    if(propertySharedSubdomain){
      domain = ';domain=' + propertySharedSubdomain + ';';
    }
    var cookieFlag = KAMPYLE_UTILS.getCookieFlagByProtocol();
    var expires = 'expires=Thu, 01 Jan 1970 00:00:00 UTC';
    document.cookie = cookieName + '= ; ' + cookieFlag + expires + ';path=/' + domain;
  },
  kampyleIsCookieEnabled: function() {
    return navigator.cookieEnabled;
  },
  kampyleCompareTimestamps: function(source, toCompare, operator)
  {
    if (typeof source !== 'number' || typeof toCompare !== 'number')
    {
      return false;
    }

    //Get only the date from the time
    source = new Date(source);
    toCompare = new Date(toCompare);
    source.setHours(0, 0, 0, 0);


    switch (operator) {
      case 'equals':
        toCompare.setHours(0, 0, 0, 0);
        return (source.getTime() === toCompare.getTime());
      case 'laterthan':
        toCompare.setHours(23, 59, 59, 999);

        return (source > toCompare);
      case 'earlierthan':
        toCompare.setHours(0, 0, 0, 0);

        return (source < toCompare);
      case 'doesnotequal':
        toCompare.setHours(0, 0, 0, 0);
        return (source.getTime() !== toCompare.getTime());
      default:
        return false;
    }
  },
  /**
   * @param  {[type]} source  the param value
   * @param  {[type]} toCompare the compared to value
   * @param  {[type]} operator    'equals' etc
   */
  kampyleCompareByOperator: function(source, toCompare, operator, varType) {
    varType = KAMPYLE_UTILS.safeToLower(varType);
    var ans = false;
    if (source === undefined)
    {
      return ans;
    }

    operator = KAMPYLE_UTILS.safeToLower(operator);
    switch (operator) {
      case KAMPYLE_CONSTANT.OPERATORS.EQUALS:
        if (varType === 'datetime') //Need to extract the date from the timstamp
        {
          ans = KAMPYLE_UTILS.kampyleCompareTimestamps(source, toCompare, operator);
        }
        else {
          ans = (source === toCompare);
        }

        break;
      case KAMPYLE_CONSTANT.OPERATORS.DOES_NOT_EQUAL:
        if (varType === 'datetime') //Need to extract the date from the timstamp
        {
          ans = KAMPYLE_UTILS.kampyleCompareTimestamps(source, toCompare, operator);
        }
        else {
          ans = (source !== toCompare);
        }
        break;

      case KAMPYLE_CONSTANT.OPERATORS.GREATER_THAN:
        ans = (source > toCompare);
        break;
      case KAMPYLE_CONSTANT.OPERATORS.LATER_THAN:
        if (varType === 'datetime') //Need to extract the date from the timstamp
        {
          ans = KAMPYLE_UTILS.kampyleCompareTimestamps(source, toCompare, operator);
        }
        else {
          ans = (source > toCompare);
        }
        break;
      case KAMPYLE_CONSTANT.OPERATORS.SMALLER_THAN:
        ans = (source < toCompare);
        break;
      case KAMPYLE_CONSTANT.OPERATORS.EARLIER_THAN:
        if (varType === 'datetime') //Need to extract the date from the timstamp
        {
          ans = KAMPYLE_UTILS.kampyleCompareTimestamps(source, toCompare, operator);
        }
        else {
          ans = (source > toCompare);
        }
        break;
      case KAMPYLE_CONSTANT.OPERATORS.CONTAINS:
        ans = (!!source && source.indexOf && source.indexOf(toCompare) !== -1);
        break;
      case KAMPYLE_CONSTANT.OPERATORS.DOES_NOT_CONTAIN:
        ans = (!!source && source.indexOf && source.indexOf(toCompare) === -1);
        break;
      case KAMPYLE_CONSTANT.OPERATORS.STARTS_WITH:
        ans = (!!source && source.indexOf && source.indexOf(toCompare) === 0);
        break;
      case KAMPYLE_CONSTANT.OPERATORS.ENDS_WITH:
        ans = (!!source && source.indexOf &&
            source.length &&
            source.indexOf(toCompare, source.length - source.length) !== -1);
        break;
      case KAMPYLE_CONSTANT.OPERATORS.HAS_VALUE:
        //Simply check that first value exists
        ans = (!!source || source === '' || source === false || source === 0);
        break;
      case KAMPYLE_CONSTANT.OPERATORS.REGEX:
        try {
          var regex = new RegExp(toCompare);
          ans = (!!source && regex.exec(source) !== null);
        } catch(e) {
          ans = false;
        }

        break;

      default:
        break;
    }
    return ans;
  },
  setNestedPropertyValue: function(obj, propString, value) {
    var schema = obj;  // a moving reference to internal objects within obj
    var pList = propString.split('.');
    var len = pList.length;
    for (var i = 0; i < len - 1; i++) {
      var elem = pList[i];
      if (!schema[elem]) {
        schema[elem] = {};
      }
      schema = schema[elem];
    }
    schema[pList[len - 1]] = value;
  },
  getNestedPropertyValue: function(obj, propString, fallback) {
    if (!obj || !propString || typeof propString !== 'string') {return null;}
    var propNameDotPlaceholder = '#DOT#';
    var props = propString.split('.');
    var tmpObj = obj;

    var len = props.length;
    for (var i = 0; i < len; i++) {
      var currProp = props[i].split(propNameDotPlaceholder).join('.');
      var propOnObjPrototypeChain = tmpObj !== null && typeof tmpObj === "object" && currProp in tmpObj;
      if (!!tmpObj && (Object.prototype.hasOwnProperty.call(tmpObj, currProp) || propOnObjPrototypeChain || tmpObj[currProp])) {
        tmpObj = tmpObj[currProp];
      } else {
        return typeof fallback === "undefined" ? null : fallback;
      }
    }

    //Reaching here means we managed to go into the object with all of propString's properties
    return tmpObj;
  },
  //function to match kampyle cdn hosts url (if cdn host name changes we'll have to update here)
  validateKampyleDomain: function(url) {
    var urlRegex = /(^https?:\/\/[A-Za-z0-9\-]+\.kampyle\.com(\/[A-Za-z0-9\-\._~:\/\?#\[\]@!$&'\(\)\*\+,;\=]*)?)/;
    var result = urlRegex.test(url);
    if (!result) {
      console.warn('Invalid url in validateKampyleDomain: ' + url);
    }

    return result;
  },
  camelToDash: function(str) {
    if (typeof str !== 'string') {
      return str;
    }
    else {
      return str.replace(/\W+/g, '-')
                .replace(/([a-z\d])([A-Z])/g, '$1-$2')
                .toLowerCase();
    }
  },

  objectPropertyObserver: function (obj, pathToProperty, callback) {

    var MAX_TIMEOUT_RUNS = 100;
    var timeoutMs = 100;
    var runsCounter = 0;

    function timoutCallback () {
      var propertyValue = KAMPYLE_UTILS.getNestedPropertyValue(obj, pathToProperty);

      if (!!propertyValue && callback instanceof Function) {
        return callback(propertyValue);
      }

      if (runsCounter++ < MAX_TIMEOUT_RUNS) {
        window.setTimeout(timoutCallback, timeoutMs);
      }
    }

    window.setTimeout(timoutCallback, timeoutMs);
  },
	showInvite: function () {
		var inviteIframe = document.getElementById('kampyleInvite');
		KAMPYLE_UTILS.setElementStyle(inviteIframe, { visibility: 'visible' }, true /* important */);
	},
	hideInvite: function () {
		var inviteIframe = document.getElementById('kampyleInvite');
		KAMPYLE_UTILS.setElementStyle(inviteIframe, { visibility: 'hidden' }, true /* important */);
  },
  getNumericValue: function(val) {

    if (val === '' || val === null) {
      return null;
    }
    if (typeof(val) !== 'number' && isNaN(Number(val))) {
      return null;
    }

    return Number(val);
  },
  extractAllObjectNonFunctionsProperties: function(obj) {
    var objectProperties = {};
    for (var key in obj) {
      if (typeof obj[key] !== "function") {
        objectProperties[key] = obj[key];
      }
    }
    return Object.keys(objectProperties).length > 0 ? objectProperties : null;
  },

  httpRequest: function(method, url, jsonData, onSuccess, onError, config) {
    var counter = 0;
    var numOfTimes = (config || {}).numOfTimes || KAMPYLE_CONSTANT.NETWORK.NUM_OF_RETRIES;
    var timeout = (config || {}).timeout || KAMPYLE_CONSTANT.NETWORK.REQUEST_TIMEOUT;
  
    function handleError(error, eventName, eventData) {
      if (counter < numOfTimes) {
        counter++;
        var timeoutBetweenRetries = KAMPYLE_UTILS.getRetryTimeout();
        setTimeout(makeRequest, timeoutBetweenRetries);
      } else {
        KAMPYLE_EVENT_DISPATCHER.trigger(eventName, eventData);
        if (typeof onError === 'function') {
          onError(error);
        }
      }
    }
  
    function makeRequest() {
      var requestStartDate = KAMPYLE_UTILS.getCurrentTimestamp();
      var beforeRequestData = {attemptNumber: counter, url: url};
  
      if (jsonData) {
        var postData = Object.assign({}, jsonData)
        beforeRequestData = Object.assign({}, beforeRequestData, {postData: postData})
      }
      if(method==='POST') {
        KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.ANALYTICS_HTTP_EVENTS_BY_METHOD.BEFORE.POST, {httpRequestData: beforeRequestData});
      }

      var xhr = new XMLHttpRequest();
  
      xhr.open(method, url, true); 
      jsonData ? xhr.setRequestHeader('Content-Type', 'application/json') : null
      xhr.timeout = timeout || 0;
  
      xhr.onerror = function (error) {
        var onErrorRequestTotalTime = KAMPYLE_UTILS.getTimeDiff(requestStartDate, KAMPYLE_CONSTANT.TIME_FORMATS.SECONDS);
        var onErrorData = {
          requestUrl: url,
          responseStatus: xhr.status,
          error: error, 
          requestTotalTimeInSeconds: onErrorRequestTotalTime
        };
        handleError(onErrorData, KAMPYLE_CONSTANT.ANALYTICS_HTTP_EVENTS_BY_METHOD.ERROR[method], {httpRequestData: onErrorData});
      };
   
      xhr.ontimeout = function (error) {
        var ontimeoutRequestTotalTime = KAMPYLE_UTILS.getTimeDiff(requestStartDate, KAMPYLE_CONSTANT.TIME_FORMATS.SECONDS);
        var onTimeoutData = {
          requestUrl: url,
          responseStatus: xhr.status,
          error: error,
          attemptNumber: counter,
          networkConnectionDetails: KAMPYLE_UTILS.extractAllObjectNonFunctionsProperties(window.navigator.connection),
          requestTotalTimeInSeconds: ontimeoutRequestTotalTime
        };
        handleError(onTimeoutData, KAMPYLE_CONSTANT.ANALYTICS_HTTP_EVENTS_BY_METHOD.TIMEOUT[method], {httpRequestData: onTimeoutData});
      };
  
      xhr.onload = function() {
        var onloadRequestTotalTime = KAMPYLE_UTILS.getTimeDiff(requestStartDate, KAMPYLE_CONSTANT.TIME_FORMATS.SECONDS);
        var responseData = KAMPYLE_UTILS.safeJsonParse(xhr.responseText);
        if (xhr.status === 200) {
          var onSuccessEventData = {
            requestUrl: url, 
            attemptNumber: counter, 
            requestTotalTimeInSeconds: onloadRequestTotalTime
          };
          KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.ANALYTICS_HTTP_EVENTS_BY_METHOD.AFTER[method], {httpRequestData: onSuccessEventData});
          
          if (typeof onSuccess === 'function') {
            onSuccess(responseData);
          }
        } else {
          var afterRequestData = {
            requestUrl: url,
            responseStatus: xhr.status,
            responseText: responseData,
            attemptNumber: counter,
            requestTotalTimeInSeconds: onloadRequestTotalTime
          };
          handleError(afterRequestData, KAMPYLE_CONSTANT.ANALYTICS_HTTP_EVENTS_BY_METHOD.ERROR_STATUS_CODE[method], {httpRequestData: afterRequestData});
        }
      };
  
      jsonData ? xhr.send(JSON.stringify(beforeRequestData.postData)) : xhr.send(); 
    }
  
    makeRequest();
  },
  
   lowerize : function (str) {
    return str.toLowerCase();
   },

   trim : function (str) {
    return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
   },

   getDeviceTypeByUserAgent: function (agent, userAgentData) {
    var FUNC_TYPE   = 'function',
      MODEL       = 'model',
      OBJ_TYPE    = 'object',
      TYPE        = 'type',
      VENDOR      = 'vendor',
      CONSOLE     = 'console',
      MOBILE      = 'mobile',
      TABLET      = 'tablet',
      SMARTTV     = 'smarttv',
      WEARABLE    = 'wearable',
      DESKTOP     = 'desktop';

    if(userAgentData && userAgentData.platform){
        return userAgentData.mobile ? MOBILE : (userAgentData.platform.toLowerCase() === 'android') ? TABLET : DESKTOP;
    }
    // We use a dedicated utility function to detect tablets running on ios13 because there isn't any other ideal way in the current implementation.
    if (KAMPYLE_UTILS.isiPadOS13()) {
      return TABLET;
    }

    var device = {};

    var arrays = [
      [
        /\((ipad|playbook);[\w\s\);-]+(rim|apple)/i                         // iPad/PlayBook
      ], [MODEL, VENDOR, [TYPE, TABLET]], [

        /applecoremedia\/[\w\.]+ \((ipad)/                                  // iPad
      ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]],[

        /(archos)\s(gamepad2?)/i,                                           // Archos
        /(hp).+(touchpad)/i,                                                // HP TouchPad
        /(hp).+(tablet)/i,                                                  // HP Tablet
        /(kindle)\/([\w\.]+)/i,                                             // Kindle
        /\s(nook)[\w\s]+build\/(\w+)/i,                                     // Nook
        /(dell)\s(strea[kpr\s\d]*[\dko])/i,                                   // Dell Streak
        /SHIELD Tablet/,
        /A500/,
        /LG-V410\/V41020c/,                                                 //LG
        /Puffin/,                                                            // Puffin browser
        /^(?!.*Mobile).*Android.*$/
      ], [VENDOR, MODEL, [TYPE, TABLET]], [

        /(kf[A-z]+)\sbuild\/[\w\.]+.*silk\//i                               // Kindle Fire HD
      ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], /*[ //TODO: CHECK THIS
       /(sd|kf)[0349hijorstuw]+\sbuild\/[\w\.]+.*silk\//i                  // Fire Phone
       ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], */ [

        /\((ip[honed|\s\w*]+);.+(apple)/i                                   // iPod/iPhone
      ], [MODEL, VENDOR, [TYPE, MOBILE]], [
        /\((ip[honed|\s\w*]+);/i                                            // iPod/iPhone
      ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [

        /(blackberry)[\s-]?(\w+)/i,                                         // BlackBerry
        /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|huawei|meizu|motorola|polytron)[\s_-]?([\w-]+)*/i,
        // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Huawei/Meizu/Motorola/Polytron
        /(hp)\s([\w\s]+\w)/i,                                               // HP iPAQ
        /(asus)-?(\w+)/i                                                    // Asus
      ], [VENDOR, MODEL, [TYPE, MOBILE]],
      [
        /\(bb10;\s(\w+)/i                                                   // BlackBerry 10
      ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [
        // Asus Tablets
        /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i
      ], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]],
      [
        /(sony)\s(tablet\s[ps])\sbuild\//i,                                  // Sony
        /(sony)?(?:sgp.+)\sbuild\//i
      ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [
        /(?:sony)?(?:(?:(?:c|d)\d{4})|(?:so[-l].+))\sbuild\//i
      ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Phone'], [TYPE, MOBILE]],
      [
        /(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i                         // Lenovo tablets
      ], [VENDOR, MODEL, [TYPE, TABLET]], [

        /(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,                               // HTC
        /(zte)-(\w+)*/i,                                                    // ZTE
        /(alcatel|geeksphone|huawei|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]+)*/i
        // Alcatel/GeeksPhone/Huawei/Lenovo/Nexian/Panasonic/Sony
      ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

        /(nexus\s9)/i                                                       // HTC Nexus 9
      ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [

        /(nexus\s6p)/i                                                      // Huawei Nexus 6P
      ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]],
      [
        /(microsoft);\s(lumia[\s\w]+)/i                                     // Microsoft Lumia
      ], [VENDOR, MODEL, [TYPE, MOBILE]],
      [
        /(kin\.[onetw]{3})/i                                                // Microsoft Kin
      ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]],
      [
        // Motorola
        /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?(:?\s4g)?)[\w\s]+build\//i,
        /mot[\s-]?(\w+)*/i,
        /(XT\d{3,4}) build\//i,
        /(nexus\s6)/i
      ], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
        /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
      ], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]],
      [
        /android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,
        /((SM-T\w+))/i
      ], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [                  // Samsung
        /smart-tv.+(samsung)/i
      ], [VENDOR, [TYPE, SMARTTV], MODEL], [
        /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,
        /(sam[sung]*)[\s-]*(\w+-?[\w-]*)*/i,
        /sec-((sgh\w+))/i
      ], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [
        /sie-(\w+)*/i                                                       // Siemens
      ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [

        /(maemo|nokia).*(n900|lumia\s\d+)/i,                                // Nokia
        /(nokia)[\s_-]?([\w-]+)*/i
      ], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [

        /android\s3\.[\s\w;-]{10}(a\d{3})/i                                 // Acer
      ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

        /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i                     // LG Tablet
      ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]],
      [
        /(nexus\s[45])/i,                                                   // LG
        /lg[e;\s\/-]+(\w+)*/i
      ], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [

        /android.+(ideatab[a-z0-9\-\s]+)/i                                  // Lenovo
      ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

        /linux;.+((jolla));/i                                               // Jolla
      ], [VENDOR, MODEL, [TYPE, MOBILE]],
      [
        /android.+;\s(oppo)\s?([\w\s]+)\sbuild/i                            // OPPO
      ], [VENDOR, MODEL, [TYPE, MOBILE]],
      [
        /android.+;\s(pixel c)\s/i                                          // Google Pixel C
      ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [

        /android.+;\s(pixel xl|pixel)\s/i                                   // Google Pixel
      ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [

        /android.+(\w+)\s+build\/hm\1/i,                                    // Xiaomi Hongmi 'numeric' models
        /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,               // Xiaomi Hongmi
        /android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d\w)?)\s+build/i    // Xiaomi Mi
      ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [

        /android.+a000(1)\s+build/i                                         // OnePlus
      ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]],
      [
        /\s(tablet)[;\/]/i,                                                 // Unidentifiable Tablet
        /\s(mobile)(?:[;\/]|\ssafari)/i                                     // Unidentifiable Mobile
      ], [[TYPE, KAMPYLE_UTILS.lowerize], VENDOR, MODEL],
      [
        /Mobile|iP(hone|od|ad)|(Android).*(Mobile|sdk)|BlackBerry|portalmmm|BOLT|Vodafone|WindowsCE|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/
      ], [VENDOR, MODEL, [TYPE, MOBILE]],
    ];
    var ua = agent || navigator.userAgent;

    //var result = {},
    var i = 0, j, k, p, q, matches, match;//, args = arguments;
    // loop through all regexes maps
    while (i < arrays.length && !matches) {

      var regex = arrays[i],       // even sequence (0,2,4,..)
        props = arrays[i + 1];   // odd sequence (1,3,5,..)
      j = k = 0;

      // try matching uastring with regexes
      while (j < regex.length && !matches) {
        matches = regex[j++].exec(ua);

        if (!!matches) {
          for (p = 0; p < props.length; p++) {
            match = matches[++k];
            q = props[p];
            // check if given property is actually array
            if (typeof q === OBJ_TYPE && q.length > 0) {
              if (q.length == 2) {
                if (typeof q[1] == FUNC_TYPE) {
                  // assign modified match
                  device[q[0]] = q[1].call(device, match);
                } else {
                  // assign given value, ignore regex match
                  device[q[0]] = q[1];
                }
              } else if (q.length == 3) {
                // check whether function or regex
                if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                  // call function (usually string mapper)
                  device[q[0]] = match ? q[1].call(device, match, q[2]) : undefined;
                } else {
                  // sanitize match using given regex
                  device[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                }
              } else if (q.length == 4) {
                device[q[0]] = match ? q[3].call(device, match.replace(q[1], q[2])) : undefined;
              }
            } else {
              device[q] = match ? match : undefined;
            }
          }
        }
      }
      i += 2;
    }

    //We only care for mobile, desktop and tablet, hence treat all other types as desktop
    if (!device[TYPE] || (device[TYPE] !== MOBILE && device[TYPE] !== TABLET)) {
      return DESKTOP;
    }
    return device[TYPE];
  },

    getElementStyle: function (domElement,styleProperty) {
      if (domElement instanceof HTMLElement) {
          try {
              return window.getComputedStyle(domElement).getPropertyValue(styleProperty);
          } catch (err) {}
      }
      return null;
    },

    isTruthy: function(expression) {
      if (typeof expression !== 'string') {
          return expression;
      }

      try {
          expression = JSON.parse(expression);
      } catch(err) {}

      return expression;
  },

  safeJsonParse: function(str, msgOnFail) {
    try {
      return JSON.parse(str);
    } catch (e) {
      KAMPYLE_UTILS.showWarning(msgOnFail ? msgOnFail : 'Failed to parse JSON, error message: ' + (e || {}).message);
      KAMPYLE_UTILS.showErrorStack(e || {});
      return null;
    }
  },

  addWcagStyleOnFocus: function(element){
    if(KAMPYLE_DATA.isFeatureEnabled(KAMPYLE_CONSTANT.FEATURE_FLAGS.WCAG)){
      element.addEventListener("focusin",function(){
        KAMPYLE_UTILS.setElementStyle(element, {
          outline: '1px dashed #595959',
          outlineOffset: '2px',
          transition: 'none'
        },true);
      })
      element.addEventListener("focusout",function(){
        element.style.outline = 'none';
        element.style.outlineOffset = null;
        element.style.transition = null;
      });
    }
  },

  addHoverEffectOnElement: function (element, defaultStyle, onHoverStyle) {
    if (element && typeof (element.addEventListener) === 'function') {
      element.addEventListener("mouseenter", function () {
        KAMPYLE_UTILS.setElementStyle(element, onHoverStyle);
      })
      element.addEventListener("mouseleave", function () {
        KAMPYLE_UTILS.setElementStyle(element, defaultStyle);
      })
    }
  },

  handleAfterFormPosition: function (eventName, data) {
    var isScrollToPostion = true;
    if(KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.NOT_SCROLL_TO_LAST_POSITION_DISPLAY_TYPE_ANIMATION)) {
      var formData = KAMPYLE_DATA.getFormData(data.formId);
      var isScrollToPostion = KAMPYLE_DATA.getDisplayType(formData) !== 'animation'
    }
    if (isScrollToPostion) {
      KAMPYLE_UTILS.scrollToLastPosition()
    }
  },
  scrollToLastPosition: function () {
      //part of NM-4853
        var position = KAMPYLE_DATA.getMemoryData('scrollPosition');
        if (position) {
            window.scroll(position.x, position.y);
            KAMPYLE_DATA.deleteMemoryData('scrollPosition');
        }
    },

  setCurrentScrollPosition: function () {

        if (!KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.NOT_SCROLL_TO_LAST_POSITION_DISPLAY_TYPE_ANIMATION) && (document.body !== document.activeElement)) {
            // if active element is not the fallback body, then the KAMPYLE_FUNC.refocusActiveElement method
            // would scroll to last active element before opening the form
          return false;
        }

        var position = KAMPYLE_UTILS.getScrollPosition() || {};
        KAMPYLE_DATA.setMemoryData('scrollPosition', { x: position.x, y: position.y });
    },

    getScrollPosition: function () {
        /*
       NM-4853
       snippet source: https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollY
       handles IE and other non compatible browsers
        */
        var isPageOffsetSupported = window.pageXOffset !== undefined;
        var isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");

        var x = isPageOffsetSupported ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
        var y = isPageOffsetSupported ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;

        return {
            x: x,
            y: y
        }
    },
    getLangCodeFromNavAPI: function() {
      return window.navigator.language || window.navigator.userLanguage || null;
    },
    getStrigifiedData: function(data){
      var strigifyData;
      if(typeof data === 'object' && data !== null){
        try{
          strigifyData = JSON.stringify(data);
        }
        catch(err){
          strigifyData = data;
        }
      }
      else{
        strigifyData = data;
      }
      return strigifyData;
    },
    appendScript: function(scriptSrc) {
      var s = document.createElement('script');
      s.src = scriptSrc;
      document.body.appendChild(s);
    },
    toBase64: function(str) {
      str = str || '';
      return btoa(unescape(encodeURIComponent(str)));
    },
    styleObjToInline: function(styleObj) {
      var inlineStyle = '';

      for (var prop in styleObj) {
        inlineStyle += prop + ':' + styleObj[prop] + ';';
      }

      return inlineStyle;
    },
    getBaseUrl: function() {
      return location.origin + location.pathname;
    },
    generateUUID: function () {
      // source https://solvit.io/10e5636
      var seed = KAMPYLE_UTILS.getCurrentTimestamp();
      if (window.performance && typeof window.performance.now === 'function') {
        seed += performance.now();
      }

      var UUID = 'xxxx-xxxx-xxxx-xxxx-xxxx-xxxx-xxxx-xxxx'.replace(/[x]/g, function () {
        var random = (seed + Math.random() * 16) % 16 | 0; // Using seed with combination with random to improve randomness probability
        seed = Math.floor(seed/16); // Resizing seed to reduce probability to hit same value for next char

        return random.toString(16);
      });

      return UUID;
    },
    getRetryTimeout: function () {
    var dataJson = KAMPYLE_DATA.getMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.DATA_JSON);
    return KAMPYLE_UTILS.getNestedPropertyValue(dataJson, 'retryTimout') || KAMPYLE_CONSTANT.NETWORK.RETRY_TIMEOUT;
  },
  isTrue: function (value) {
    return value === true || value === "true"
  },
  isValueNumericAndDefined: function (value) {
    var isValueDefined = !!value;
    var isValueNumeric = !isNaN(value);
    return isValueDefined && isValueNumeric;
  },
  focusElement: function (element) {
    if (element && typeof element.focus === 'function') {
      element.focus();
    }
  },

  fakePromise: function(val) {
    return {
      then: function(resolver) {
        resolver(val);
      }
    }
  },

  textEncode: function(str) {
    if (window.TextEncoder) {
      return new TextEncoder('utf-8').encode(str);
    }
    var utf8 = unescape(encodeURIComponent(str));
    var result = new window.Uint8Array(utf8.length);
    for (var i = 0; i < utf8.length; i++) {
        result[i] = utf8.charCodeAt(i);
    }
    return result;
  },

  toHex: function(buffer) {
    var byteArray = new window.Uint8Array(buffer);
    var hexParts = [];
    for(var i = 0; i < byteArray.length; i++) {
      var hex = byteArray[i].toString(16);
      var paddedHex = ('00' + hex).slice(-2);
      hexParts.push(paddedHex);
    }
    
    return hexParts.join('');
  },

  sha512: function (str) {
    var cryptoObj = window.crypto;

    // Return null when the ability to encode is not supported
    if (!(cryptoObj && cryptoObj.subtle) || !str || !window.Uint8Array) {
      return KAMPYLE_UTILS.fakePromise(null);
    }
    var buffer = KAMPYLE_UTILS.textEncode(str);
    var digest = cryptoObj.subtle.digest('SHA-256', buffer);
    if (typeof digest.then === 'function' && typeof digest.catch === 'function') {
      return digest.then(function(hash) {
        return KAMPYLE_UTILS.toHex(hash);
      }).catch(function() {return null;});
    }
    return KAMPYLE_UTILS.fakePromise(null);
  },

  isModalFormType: function (formId) {
    var formData = KAMPYLE_DATA.getFormData(formId);
    var displayType = KAMPYLE_DATA.getDisplayType(formData);

    // Trap focus feature shouldn't apply to embedded forms or forms with popup display type
    var validFormTypes = (
      Boolean(formData) &&
      Boolean(displayType) &&
      formData.formType !== KAMPYLE_CONSTANT.FORM_TYPES.EMBEDDED &&
      displayType !== KAMPYLE_CONSTANT.DISPLAY_TYPES.POPUP
    );

    // for new modal should not apply to animate
    return KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.NEW_MODAL_DIALOGS) ?
      validFormTypes && displayType !== KAMPYLE_CONSTANT.DISPLAY_TYPES.ANIMATION :
      validFormTypes;
  },
  isFormInPreviewContext: function (formId) {
    var formState = KAMPYLE_DATA.getFormState(formId);
    return formState != null && (formState.triggerType == "Preview" || formState.triggerType == "DraftPreview")
  },

  setSpinnerStyle: function  (spinnerContainerElement,spinnerSize,iframe) {
    if (!(spinnerContainerElement || spinnerSize)) return;

    var spinerSizes = {
      small: { widthHeight: 15, border: 3 },
      large: { widthHeight: 40, border: 4 },
    }
    var halfSpinnerSize = (spinerSizes[spinnerSize]['widthHeight']/2) + spinerSizes[spinnerSize]['border'];
    var spinner = spinnerContainerElement.querySelector('#'+KAMPYLE_CONSTANT.SPINNER_SETTINGS.ID);
 
    var spinnerContainerStyle = {
      'display': 'block',
      'height': '100%',
      'z-index': '2147483647'
    }
    if (spinnerSize === KAMPYLE_CONSTANT.SPINNER_SETTINGS.SIZE.LARGE) {
      spinnerContainerStyle.position = 'absolute';
      spinnerContainerStyle.width = '100%';
      spinnerContainerStyle.top = 0;
    }

    KAMPYLE_UTILS.setElementStyle(spinner, {
      'border': spinerSizes[spinnerSize]['border'] +  'px solid #f3f3f3',
      'border-radius': '50%',
      'width': spinerSizes[spinnerSize]['widthHeight']+'px',
      'height': spinerSizes[spinnerSize]['widthHeight']+'px',
      'border-top':  spinerSizes[spinnerSize]['border'] + 'px solid #4050C6',
      'margin-top': '5px',
      'margin-right': '5px',
      'top': 'calc(50% - ' + halfSpinnerSize + 'px)',
      'left': 'calc(50% - ' + halfSpinnerSize + 'px)',
      'position': 'relative',
    }, true);

    KAMPYLE_UTILS.setElementStyle(spinnerContainerElement, spinnerContainerStyle, true);

    if (!KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.CSP_RULES)) {
      KAMPYLE_UTILS.setElementStyle(spinner, {
        'animation': KAMPYLE_CONSTANT.CSS_SETTINGS.ANIMATION_RULE_SPIN_NAME + ' 1s linear infinite'
      }, true);
      KAMPYLE_UTILS.setAnimationRule(KAMPYLE_CONSTANT.CSS_SETTINGS.ANIMATION_RULE_SPIN_NAME, '{0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); }}', iframe);
    }
    else {
      spinner.animate(
        [
          { transform: "rotate(0deg)" },
          { transform: "rotate(360deg)" },
        ],
        {
          duration: 1000,
          iterations: Infinity,
        }
      );
    }
  },
  getParsedUrl: function (url) {
    try {
      var urlParser = document.createElement('a');
      urlParser.href = url;
  
      return {
        protocol: urlParser.protocol,
        host: urlParser.host,
        hostname: urlParser.hostname,
        port: urlParser.port,
        pathname: urlParser.pathname,
        hash: urlParser.hash,
        search: urlParser.search,
        origin: urlParser.origin
      }
    } catch (e) {
      console.error('Not valid URL' + url);
  
      return null;
    }
  },
  debounce: function(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  },
  getOrCreateWrapperContainer: function (wrapperId) {
    return document.getElementById(wrapperId) ||
      Object.assign(document.createElement('span'), {
        id: wrapperId
      });
  }
};
